<template>
    <v-card>
        <v-dialog v-model="dialogDelete" max-width="600px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline red--text text--darken-1" v-text="$t('title.deleteSeverity')"></span>
                </v-card-title>
                <v-card-text>
                    <span class="subtitle-2 text--darken-1" v-text="$t('title.deleteSeverityReplace')"></span>
                </v-card-text>

                <v-card-text>
                    <severity-selector v-model="editSeverity.replace" />
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="cancelEdit">
                        {{ $t('buttons.cancel') }}
                    </v-btn>
                    <v-btn color="red" dark @click="deleteObject">
                        {{ $t('buttons.delete') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-card-text v-if="editSeverity && dialog">
            <v-card flat>
                <v-card-title>
                    <span class="headline blue--text text--darken-1">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                    <v-text-field
                        v-model="editSeverity.value"
                        :label="$t('severities.attributes.value')"
                        required
                        color="red"
                    ></v-text-field>
                    <v-text-field
                        v-model="editSeverity.label"
                        :label="$t('severities.attributes.label')"
                        required
                        color="red"
                    ></v-text-field>
                    <v-textarea
                        v-model="editSeverity.description"
                        :label="$t('severities.attributes.description')"
                    ></v-textarea>
                    <v-color-picker
                        v-model="editSeverity.color"
                        hide-canvas
                        hide-mode-switch
                        show-swatches
                        hide-inputs
                        flat
                        width="100%"
                        height="200"
                        class="mb-4"
                    ></v-color-picker>
                    <v-switch v-model="editSeverity.default" :label="$t('severities.attributes.default')"></v-switch>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="cancelEdit">
                        {{ $t('buttons.cancel') }}
                    </v-btn>
                    <v-btn color="success" @click="saveObject">
                        {{ editSeverity.id ? $t('buttons.refresh') : $t('buttons.add') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-card-text>

        <v-card-text v-else>
            <v-data-table
                :headers="headers"
                :items="severities"
                sort-by="value"
                :items-per-page="20"
                :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100, 200],
                    'show-current-page': true,
                    'show-first-last-page': true,
                }"
            >
                <template v-slot:top>
                    <v-toolbar flat color="transparent">
                        <v-spacer></v-spacer>
                        <v-btn rounded color="primary" dark @click="dialog = true">
                            {{ $t('buttons.createSeverity') }}
                        </v-btn>
                    </v-toolbar>
                </template>

                <template v-slot:[`item.color`]="{ item }">
                    <v-avatar :color="item.color" size="36"> &nbsp; </v-avatar>
                </template>
                <template v-slot:[`item.value`]="{ item }">
                    <span :class="item.default ? 'subtitle-2' : ''">{{ item.value }}</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
                    <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import severitySelector from '@/components/selectors/simple/severity';

import Clone from 'lodash/cloneDeep';

export default {
    name: 'settings-severities',
    data: () => ({
        dialog: false,
        dialogDelete: false,
        editSeverity: {
            color: '#000000',
        },
    }),
    created() {
        this.findSeverities();
    },
    components: {
        severitySelector,
    },
    watch: {},
    computed: {
        ...mapGetters(['severities']),
        headers() {
            return [
                {
                    text: '',
                    sortable: false,
                    value: 'color',
                    width: 36,
                },
                {
                    text: this.$t('severities.attributes.value'),
                    sortable: true,
                    value: 'value',
                },
                {
                    text: this.$t('severities.attributes.label'),
                    sortable: true,
                    value: 'label',
                },
                {
                    text: this.$t('severities.attributes.actions'),
                    sortable: false,
                    value: 'actions',
                    width: 50,
                },
            ];
        },
        formTitle() {
            return this.editSeverity.id ? this.$t('title.editSeverity') : this.$t('title.newSeverity');
        },
    },
    methods: {
        ...mapActions(['findSeverities', 'createSeverity', 'updateSeverity', 'deleteSeverity']),
        cancelEdit() {
            this.dialog = false;
            this.dialogDelete = false;
            this.editSeverity = { color: '#000000' };
        },
        editItem(item) {
            this.dialog = true;
            this.editSeverity = Clone(item);
        },
        deleteItem(item) {
            this.dialogDelete = true;
            this.editSeverity = Clone(item);
        },
        deleteObject() {
            this.deleteSeverity(this.editSeverity);
            this.cancelEdit();
        },
        saveObject() {
            if (this.editSeverity.id) {
                this.updateSeverity(this.editSeverity);
            } else {
                this.createSeverity(this.editSeverity);
            }
            this.cancelEdit();
        },
    },
};
</script>

<style></style>
